import { createLocalStorageStateHook } from 'use-local-storage-state';

export const DEFAULT_MEASUREMENT_DURATION = 60;
export const MIN_MEASUREMENT_DURATION = 20;
export const MAX_MEASUREMENT_DURATION = 180;

export const useLicenseKey = createLocalStorageStateHook('licenseKey', '003E6F-0E2908-44E7A0-4F9EF5-5A5BB4-A12559');
export const useProductId = createLocalStorageStateHook('productId', 'd9769f03-74fe-4f81-98e9-03107291e3b8');
export const useMeasurementDuration = createLocalStorageStateHook(
  'measurementDuration',
  DEFAULT_MEASUREMENT_DURATION,
);
